module.exports = "<i class=\"fas fa-circle-notch myprogress fa-5x\"></i>"